var _path, _line, _path2, _line2, _circle, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBidLogoOnText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 27,
    viewBox: "0 0 46 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66259 25.1428C4.44506 25.1428 1.83678 22.5346 1.83678 19.3171C1.83678 16.0997 4.44506 13.4914 7.66259 13.4914C10.8801 13.4914 13.4884 16.0997 13.4884 19.3171C13.4884 22.5346 10.8801 25.1428 7.66259 25.1428Z",
    stroke: "#6F52EA",
    strokeWidth: 3.67947
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.76036,
    y1: 19.0873,
    x2: 1.76036,
    y2: 5.44255,
    stroke: "#6F52EA",
    strokeWidth: 3.52616,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3374 25.1428C41.5549 25.1428 44.1632 22.5346 44.1632 19.3171C44.1632 16.0997 41.5549 13.4914 38.3374 13.4914C35.1199 13.4914 32.5116 16.0997 32.5116 19.3171C32.5116 22.5346 35.1199 25.1428 38.3374 25.1428Z",
    stroke: "#6F52EA",
    strokeWidth: 3.67947
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.76308,
    y1: -1.76308,
    x2: 15.4078,
    y2: -1.76308,
    transform: "matrix(0 -1 -1 0 42.4766 20.8503)",
    stroke: "#6F52EA",
    strokeWidth: 3.52616,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0003,
    cy: 4.90593,
    r: 3.67947,
    transform: "rotate(90 23.0003 4.90593)",
    stroke: "#6F52EA",
    strokeWidth: 2.45298
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0078 13.9513L23.0078 24.6831",
    stroke: "#6F52EA",
    strokeWidth: 4.59934,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidLogoOnText);
export default __webpack_public_path__ + "static/media/bidLogoOnText.13a43e5b69dcb6cc8dbd2f98b88c19c8.svg";
export { ForwardRef as ReactComponent };